import React, { useState, useEffect, useRef } from "react";
import queryString from "query-string";
import { Form, Progress, Alert, Input, Row, Col, Container } from "reactstrap";
import { CSSTransition } from "react-transition-group";

import { useLocalization } from "../../containers/I18nProvider";
import { WithCaptcha } from '../../containers/captcha';
import aside from './img/aside.png'

const LoginForm = ({ api, location, TurnstileComponent, ...props }) => {
  const nodeRef = useRef(null);
  const { translate, changeDefaultLocale } = useLocalization();
  changeDefaultLocale('es');
  const [onLogin, setOnLogin] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [error, setError] = useState({
    open: false,
    message: "",
  });
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const parameters = queryString.parse(location.search);

  useEffect(() => {
    setShowForm(true)
  }, []);

  const onSubmit = async (ev) => {
    ev.preventDefault();
    setOnLogin(true)
    setError({
      open: false,
      message: "",
    })

    api.userPassLogin(
      {
        username,
        password,
      },
      parameters
    )
      .then((response) => {
        setOnLogin(false)
        window.location = parameters.redirect_uri + "?" + queryString.stringify(response);
      })
      .catch((error) => {
        const _translate = translate(error.errorCode);

        let message = translate("RequestLoginErrorMessage");

        if (_translate) {
          message = _translate;
        } else if (error.details) {
          message = error.details;
        }
        setOnLogin(false)
        setError({ open: true, message: message })
      });
  }

  return (
    <CSSTransition
      in={showForm}
      timeout={300}
      classNames="formshow"
      nodeRef={nodeRef}
      unmountOnExit
    >
      <div className="login-treximagen-container" ref={nodeRef}>
        <div className="logo-arriba-div"><img src={aside} alt="aside" className="logo-arriba" /></div>
        <Form className="login-form" onSubmit={(event) => onSubmit(event)}>
          <Container fluid={true} className="treximagen-form-container">
            <h1 className="desc-trex">{translate("ClientAuthentication")}</h1>
            <div className="treximagen-separator"></div>
            <Row className="treximagen-form-body">
              <Col sm="12" xs="12" md="12" className="treximagen-input">
                <div><p className="detail-trex">{translate("PlaceholderUserName")}</p></div>
                <Input
                  className="user-input-treximagen"
                  disabled={onLogin}
                  required={true}
                  tabIndex={1}
                  type="text"
                  autoCorrect="off"
                  autoCapitalize="none"
                  id="username"
                  onChange={e => setUsername(e.target.value)}
                  placeholder={translate("PlaceholderUserName")}
                />
              </Col>
              <Col sm="12" xs="12" md="12" className="treximagen-input">
                <div><p className="detail-trex">{translate("PlaceholderPassword")}</p></div>
                <Input
                  className="pass-input-treximagen"
                  required={true}
                  disabled={onLogin}
                  tabIndex={1}
                  type="password"
                  autoCorrect="off"
                  autoCapitalize="none"
                  id="password"
                  placeholder="**************"
                  onChange={e => setPassword(e.target.value)}
                />
              </Col>
              <Col sm="12" xs="12" md="12" className="treximagen-input">
                {!onLogin ? (
                  <button
                    tabIndex={1}
                    type="submit"
                    id="submmit"
                    className="enter-treximagen"
                    disabled={!props.turnstileSuccess}
                  >
                    {translate("ButtonEnter")}
                  </button>
                ) : (
                  <Progress animated color="danger" value={100} />
                )}
              </Col>

            </Row>
            <div className="messages-container">
              <Alert
                color="danger"
                id="error-message"
                isOpen={error.open}
                toggle={() => setError({ open: false })}
              >
                {error.message}
              </Alert>
            </div>
            <Row>
              <Col style={{ padding: '0' }}>
                <TurnstileComponent setTurnstileSuccess={props.setTurnstileSuccess} />
              </Col>
            </Row>
          </Container>
        </Form>
        <div className="logo-costad-div"><img src={aside} alt="aside" className="logo-costado" /></div>
      </div>
    </CSSTransition>
  );
}

export default WithCaptcha(LoginForm, { useInsideForm: true, style: { marginTop: '2rem' } });
